/**
 * Single source for the icon subset (scripts/subset-icons.mjs reads this file) and `IconName`.
 * Codepoints are Material Symbols Rounded's private-use points (google/material-design-icons
 * `MaterialSymbolsRounded*.codepoints`). Rendering by codepoint keeps the subset to exactly these
 * glyphs: ligature (GSUB) closure would otherwise pull in every icon spellable from the letters.
 */
export const ICON_CODEPOINTS = {
  add: 0xe145,
  apartment: 0xea40,
  arrow_back: 0xe5c4,
  block: 0xf08c,
  call: 0xf0d4,
  calendar_month: 0xebcc,
  campaign: 0xef49,
  check: 0xe668,
  chat_bubble: 0xe0cb,
  chevron_left: 0xe5cb,
  chevron_right: 0xe5cc,
  close: 0xe5cd,
  construction: 0xea3c,
  dashboard: 0xe871,
  delete: 0xe92e,
  description: 0xe873,
  door_front: 0xeffd,
  door_sliding: 0xeffe,
  edit: 0xf097,
  error: 0xf8b6,
  flag: 0xf0c6,
  group: 0xea21,
  how_to_vote: 0xe175,
  image: 0xe3f4,
  info: 0xe88e,
  inventory_2: 0xe1a1,
  key: 0xe73c,
  link_off: 0xe16f,
  local_shipping: 0xe558,
  location_on: 0xf1db,
  lock: 0xe899,
  logout: 0xe9ba,
  mail: 0xe159,
  menu: 0xe5d2,
  move_to_inbox: 0xe168,
  notifications: 0xe7f5,
  payments: 0xef63,
  person: 0xf0d3,
  pets: 0xe91d,
  photo_camera: 0xe412,
  poll: 0xf0cc,
  remove: 0xe15b,
  schedule: 0xefd6,
  search: 0xef7a,
  send: 0xe163,
  shield: 0xe9e0,
  swap_vert: 0xe8d5,
  trending_up: 0xe8e5,
  upload: 0xf09b,
  visibility: 0xe8f4,
  volume_off: 0xe04f,
} as const

export type IconName = keyof typeof ICON_CODEPOINTS

export const ICON_NAMES = Object.keys(ICON_CODEPOINTS) as IconName[]
